import React from "react";
import Footer from '../components/Footer';
import '../styles/Privacy.css';

const PrivacyPolicy = () => {
    return (
        <div>
            <div className="main-container">
                <h1>1. Introduction</h1>
                <p><strong>MB: Menu & Catalog Maker</strong> ("the App") values your privacy. This Privacy Policy explains how we collect, use, and protect your personal information when you use the App.</p>

                <h1>2. Information We Collect</h1>
                <p>When you create an account and use the App, we may collect the following information:</p>
                <ul>
                    <li><strong>Personal Information:</strong> Your email address, business name, business phone, business address, and website.</li>
                    <li><strong>Business Information:</strong> Photos of your products and information about your business that you choose to upload.</li>
                </ul>

                <h1>3. How We Use Your Information</h1>
                <p>We use the information we collect for the following purposes:</p>
                <ul>
                    <li>To provide and maintain the App and its services.</li>
                    <li>To improve the functionality and user experience of the App.</li>
                    <li>To communicate with you about updates, features, and promotions.</li>
                    <li>To comply with legal obligations.</li>
                </ul>

                <h1>4. Data Sharing</h1>
                <p>We do not sell, rent, or share your personal information with third parties for marketing purposes. However, we may share your data with third-party service providers who assist us in operating the App or as required by law.</p>

                <h1>5. Data Security</h1>
                <p>We take reasonable steps to protect your information from unauthorized access, alteration, or destruction. However, no method of transmission over the internet is completely secure, and we cannot guarantee absolute security.</p>

                <h1>6. Data Retention</h1>
                <p>We retain your information for as long as your account is active or as needed to provide the services.</p>

                <h1>7. Your Rights</h1>
                <p>Depending on your location, you may have rights regarding your personal data, including the right to access, correct, or delete your information. If you wish to exercise any of these rights, please contact us.</p>

                <h1>8. Changes to the Privacy Policy</h1>
                <p>We may update this Privacy Policy from time to time. If changes are made, we will notify users via email. Your continued use of the App after any changes indicates your acceptance of the updated policy.</p>

                <h1>9. Contact Information</h1>
                <p>If you have any questions about this Privacy Policy, please contact us at <strong>info@monbusinessapp.com</strong>.</p>
            </div>
            <Footer />
        </div>
    )
};

export default PrivacyPolicy;